import React, { useEffect, useState } from "react";
import { fetchAllData, fetchData, fetchDeleteData, fetchUpdateData } from "../../helpers/externapi";
import MapBoxHospital from "../../Components/MapBoxHospital";
import { fetchConfigValues, formatDate, formatDate1 } from "../../Commoncomponents/CommonComponents";
import TableContainer from "@mui/material/TableContainer";
import ConfirmationDialogDelete from "../../Components/ConfirmationDialogDelete";
import Paper from "@mui/material/Paper";
import { useNavigate, useParams } from "react-router-dom";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Chip,
  Tooltip,
  CircularProgress,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Box,
  TextField
} from "@mui/material";
import Select from "react-select";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Avatar,
  IconButton
} from "@mui/material";
import { Edit, Delete, Visibility, ExpandMore, VideoCall } from "@mui/icons-material";

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

// Custom styles for react-select
const selectStyles = {
  control: (provided, state) => ({
    ...provided,
    minHeight: '45px',
    border: state.isFocused ? '2px solid #0066cc' : '1px solid #d1d5db',
    borderRadius: '8px',
    boxShadow: state.isFocused ? '0 0 0 3px rgba(0, 102, 204, 0.1)' : 'none',
    '&:hover': {
      border: '1px solid #9ca3af'
    }
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected ? '#0066cc' : state.isFocused ? '#f3f4f6' : 'white',
    color: state.isSelected ? 'white' : '#374151',
    padding: '12px 16px',
    cursor: 'pointer'
  }),
  multiValue: (provided) => ({
    ...provided,
    backgroundColor: '#e1f5fe',
    borderRadius: '6px'
  }),
  multiValueLabel: (provided) => ({
    ...provided,
    color: '#0277bd',
    fontWeight: '500'
  }),
  multiValueRemove: (provided) => ({
    ...provided,
    color: '#0277bd',
    '&:hover': {
      backgroundColor: '#b3e5fc',
      color: '#01579b'
    }
  })
};

export default function SmartClinicPersonalDetails(props) {
  const profile = props.data;
  const [imageUrl, setImageUrl] = useState('');
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [confirmationOpen, setConfirmationOpen] = useState(false);
  const [confirmationData, setConfirmationData] = useState({});
  const { Id } = useParams();
  const navigate = useNavigate();
  const [snackbarOpen, setSnackbarOpen] = useState(false);

  // Hospital assignment states
  const [hospitalDialogOpen, setHospitalDialogOpen] = useState(false);
  const [allHospitals, setAllHospitals] = useState([]);
  const [assignedHospitals, setAssignedHospitals] = useState([]);
  const [selectedHospitals, setSelectedHospitals] = useState([]);
  const [hospitalOptions, setHospitalOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [hospitalLoading, setHospitalLoading] = useState(false);
  const [users, setUsers] = useState([]);
  const [usersLoading, setUsersLoading] = useState(false);

  // Hospital details states
  const [hospitalDetails, setHospitalDetails] = useState({});
  const [hospitalDoctors, setHospitalDoctors] = useState({});
  const [hospitalSpocs, setHospitalSpocs] = useState({});
  const [hospitalSpecializations, setHospitalSpecializations] = useState({});
  const [doctorTimings, setDoctorTimings] = useState({});
  const [hospitalDetailsLoading, setHospitalDetailsLoading] = useState({});

  // Video call states
  const [videoCallDialogOpen, setVideoCallDialogOpen] = useState(false);
  const [selectedDoctor, setSelectedDoctor] = useState(null);
  const [selectedPatient, setSelectedPatient] = useState(null);
  const [videoCallLoading, setVideoCallLoading] = useState(false);
  const [patients, setPatients] = useState([]);
  const [patientsLoading, setPatientsLoading] = useState(false);
  const [activeVideoCall, setActiveVideoCall] = useState(null);
  const [patientSearch, setPatientSearch] = useState('');
  const [isActive, setIsActive] = useState(true);
  const [confirm, setConfirm] = useState(null);
  const [toast, setToast] = useState({
    show: false,
    message: "",
    variant: "success",
  });

  const handleSnackbarClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setSnackbarOpen(false);
  };

  useEffect(() => {
    const getImageUrl = async () => {
      const { userImagesBucketlink } = await fetchConfigValues();
      setImageUrl(userImagesBucketlink || '');
    };

    getImageUrl();

  }, []);

  const showToast = (message, variant = "success") =>
    setToast({ show: true, message, variant });

  useEffect(() => {
    fetchAssignedHospitals();
  }, [isActive])

  // Fetch patients for video calling
  const fetchPatients = async () => {
    try {
      setPatientsLoading(true);
      const response = await fetchAllData(`lambdaAPI/SmartClinics/GetCustomersBySmartClinicId/${profile.SmartClinicId}`);
      if (response) {
        setPatients(response);
      }
    } catch (error) {
      console.error("Error fetching patients:", error);
      setSnackbarMessage("Failed to load patients. Please try again.");
      setSnackbarOpen(true);
    } finally {
      setPatientsLoading(false);
    }
  };

  // Initiate video call
  const initiateVideoCall = async (doctorId, patientId) => {
    try {
      setVideoCallLoading(true);

      const payload = {
        CallerId: doctorId,
        ReceiverId: patientId,
        CallerType: "Doctor",
        ReceiverType: "Customer"
      };

      const response = await fetchData("lambdaAPI/VideoCall/initiate", payload);

      if (response && response.status) {
        setActiveVideoCall({
          ...response.data,
          videoCallLogId: response.data.videoCallLogId || response.data.id,
          meetingUrl: response.meetingUrl,
          doctorName: selectedDoctor?.FullName || 'Doctor',
          patientName: selectedPatient?.Name || selectedPatient?.PatientName || 'Patient',
          startTime: new Date()
        });

        setSnackbarMessage(`Video call initiated successfully! Room: ${response.data.roomName}. Notification sent to patient.`);
        setSnackbarOpen(true);
        setVideoCallDialogOpen(false);

        // Open the meeting URL in a new tab
        window.open(response.meetingUrl, '_blank');

        // Note: Patient receives notification and must accept the call.
        // When patient accepts, the patient-side application should call:
        // https://localhost:56906/lambdaAPI/VideoCall/accept/{videoCallLogId}
      } else {
        setSnackbarMessage(response?.message || "Failed to initiate video call");
        setSnackbarOpen(true);
      }
    } catch (error) {
      console.error("Error initiating video call:", error);
      setSnackbarMessage("Failed to initiate video call. Please try again.");
      setSnackbarOpen(true);
    } finally {
      setVideoCallLoading(false);
    }
  };

  // End video call and update CallEndTime and Duration
  const handleEndCall = async () => {
    if (!activeVideoCall?.videoCallLogId) {
      setSnackbarMessage("No active call to end.");
      setSnackbarOpen(true);
      return;
    }

    const endTime = new Date();
    const duration = Math.round((endTime - activeVideoCall.startTime) / 60000); // Duration in minutes

    try {
      const payload = {
        videoCallLogId: activeVideoCall.videoCallLogId,
        CallEndTime: endTime.toISOString(),
        Duration: duration
      };

      const response = await fetchData("lambdaAPI/VideoCall/update", payload);

      if (response && response.status) {
        setSnackbarMessage("Call ended successfully.");
        setSnackbarOpen(true);
        setActiveVideoCall(null);
      } else {
        setSnackbarMessage(response?.message || "Failed to end call.");
        setSnackbarOpen(true);
      }
    } catch (error) {
      console.error("Error ending video call:", error);
      setSnackbarMessage("Failed to end call. Please try again.");
      setSnackbarOpen(true);
    }
  };

  // Handle video call dialog open
  const handleVideoCallDialog = (doctor) => {
    setSelectedDoctor(doctor);
    setVideoCallDialogOpen(true);
    fetchPatients();
  };

  // Fetch assigned hospitals
  const fetchAssignedHospitals = async () => {
    try {
      const response = await fetchData("lambdaAPI/SmartClinicHospitals/GetSmartClinicHospitals", {
        "smartClinicId": profile.SmartClinicId,
        "isActive": isActive
      });
      setAssignedHospitals(response);
    } catch (error) {
      console.error("Error fetching assigned hospitals:", error);
    }
  };

  // Fetch doctor timings for current week
  const fetchDoctorTimings = async (doctors, hospitalId) => {
    const timingsData = {};
    const today = new Date();

    // Calculate current week's Sunday (start of week)
    const startOfWeek = new Date(today);
    startOfWeek.setDate(today.getDate() - today.getDay()); // Sunday

    // Calculate current week's Saturday (end of week)
    const endOfWeek = new Date(startOfWeek);
    endOfWeek.setDate(startOfWeek.getDate() + 6); // Saturday

    for (const doctor of doctors) {
      try {
        // Format dates as YYYY-MM-DD without time
        const formattedStartDate = startOfWeek.toISOString().split('T')[0];
        const formattedEndDate = endOfWeek.toISOString().split('T')[0];

        const timingResponse = await fetchData(
          'lambdaAPI/DoctorTimings/GetDoctorTimingsByDateRange',
          {
            doctorId: doctor.DoctorId,
            startDate: formattedStartDate,
            endDate: formattedEndDate
          }
        );

        timingsData[doctor.DoctorId] = timingResponse || [];
      } catch (error) {
        console.error(`Error fetching timings for doctor ${doctor.DoctorId}:`, error);
        timingsData[doctor.DoctorId] = [];
      }
    }

    setDoctorTimings(timingsData);
  };

  // Fetch hospital details including doctors, SPOCs, and specializations
  const fetchHospitalDetails = async (hospitalId) => {
    setHospitalDetailsLoading(prev => ({ ...prev, [hospitalId]: true }));

    try {
      // Fetch doctors
      const doctorResponse = await fetchAllData(`Doctor/GetByHospitalId/${hospitalId}`);
      setHospitalDoctors(prev => ({ ...prev, [hospitalId]: doctorResponse || [] }));

      // Fetch timings for each doctor
      if (doctorResponse && doctorResponse.length > 0) {
        await fetchDoctorTimings(doctorResponse, hospitalId);
      }

      // Fetch SPOC contacts
      const spocResponse = await fetchAllData(`HospitalContact/GetByHospitalId/${hospitalId}`);
      setHospitalSpocs(prev => ({ ...prev, [hospitalId]: spocResponse || [] }));

      // Fetch specializations
      const specializationResponse = await fetchAllData(`lambdaAPI/HospitalSpecializations/GetByHospitalId/${hospitalId}`);
      setHospitalSpecializations(prev => ({ ...prev, [hospitalId]: specializationResponse || [] }));

    } catch (error) {
      console.error(`Error fetching hospital ${hospitalId} details:`, error);
    } finally {
      setHospitalDetailsLoading(prev => ({ ...prev, [hospitalId]: false }));
    }
  };

  const formatTime = (timeString) => {
    if (!timeString) return '';
    const [hours, minutes] = timeString.split(':');
    const hour = parseInt(hours);
    const ampm = hour >= 12 ? 'PM' : 'AM';
    const hour12 = hour % 12 || 12;
    return `${hour12}:${minutes} ${ampm}`;
  };

  const getTodayTiming = (doctorId) => {
    const today = new Date().toISOString().split('T')[0];
    const timings = doctorTimings[doctorId] || [];

    const todayTimings = timings.filter(t => t.ScheduleDate.split('T')[0] === today);

    if (todayTimings.length === 0) return null;

    const leaveRecord = todayTimings.find(t => !t.IsActive && t.LeaveDate);
    const availableRecord = todayTimings.find(t => t.IsActive && t.StartTime && t.EndTime);
    const unavailableRecord = todayTimings.find(t => t.IsActive && t.UnavailableStartTime && t.UnavailableEndTime);

    const isLeave = !!leaveRecord;
    const isPartial = !!unavailableRecord && !!availableRecord;
    const isAvailable = !!availableRecord && !isLeave;

    return {
      isLeave,
      isPartial,
      isAvailable,
      availableTime: availableRecord,
      unavailableTime: unavailableRecord,
      reason: leaveRecord?.Reason || unavailableRecord?.Reason
    };
  };

  const getWeekTimings = (doctorId) => {
    const timings = doctorTimings[doctorId] || [];
    const weekDays = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

    const weekStart = new Date();
    weekStart.setDate(weekStart.getDate() - weekStart.getDay());

    const weekSchedule = [];
    for (let i = 0; i < 7; i++) {
      const date = new Date(weekStart);
      date.setDate(date.getDate() + i);
      const dateStr = date.toISOString().split('T')[0];

      const dayTimings = timings.filter(t => t.ScheduleDate.split('T')[0] === dateStr);
      const isToday = dateStr === new Date().toISOString().split('T')[0];

      if (dayTimings.length > 0) {
        const leaveRecord = dayTimings.find(t => !t.IsActive && t.LeaveDate);
        const availableRecord = dayTimings.find(t => t.IsActive && t.StartTime && t.EndTime);
        const unavailableRecord = dayTimings.find(t => t.IsActive && t.UnavailableStartTime && t.UnavailableEndTime);

        const isLeave = !!leaveRecord;
        const isPartial = !!unavailableRecord && !!availableRecord;
        const isAvailable = !!availableRecord && !isLeave;

        weekSchedule.push({
          date: dateStr,
          dayOfWeek: weekDays[date.getDay()],
          isToday,
          isLeave,
          isPartial,
          isAvailable,
          availableTime: availableRecord,
          unavailableTime: unavailableRecord,
          reason: leaveRecord?.Reason || unavailableRecord?.Reason
        });
      } else {
        weekSchedule.push({
          date: dateStr,
          dayOfWeek: weekDays[date.getDay()],
          isToday,
          isLeave: false,
          isPartial: false,
          isAvailable: false,
          availableTime: null,
          unavailableTime: null,
          reason: null
        });
      }
    }

    return weekSchedule;
  };

  // Fetch all hospitals for assignment
  const fetchAllHospitals = async () => {
    try {
      setHospitalLoading(true);
      const response = await fetchData("Hospital/all", { skip: 0, take: 0 });

      if (response) {
        setAllHospitals(response);

        const assignedHospitalIds = assignedHospitals.map(h => h.HospitalId || h.hospitalId);
        const availableHospitals = response.filter(
          hospital => !assignedHospitalIds.includes(hospital.HospitalId || hospital.id)
        );

        const options = availableHospitals.map(hospital => ({
          value: hospital.HospitalId || hospital.id,
          label: `${hospital.HospitalName || hospital.name}`,
          hospital: hospital
        }));

        setHospitalOptions(options);
      }
    } catch (error) {
      console.error("Error fetching hospitals:", error);
      setSnackbarMessage("Failed to fetch hospitals. Please try again.");
      setSnackbarOpen(true);
    } finally {
      setHospitalLoading(false);
    }
  };

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        setUsersLoading(true);
        const response = await fetchAllData(`lambdaAPI/User/GetUsersBySmartClinicId/${profile.SmartClinicId}`);
        if (response) {
          setUsers(response);
        }
      } catch (error) {
        console.error("Error fetching users:", error);
        setSnackbarMessage("Failed to load users. Please try again.");
        setSnackbarOpen(true);
      } finally {
        setUsersLoading(false);
      }
    };

    if (profile?.SmartClinicId) {
      fetchUsers();
    }
  }, [profile?.SmartClinicId]);

  const handleDeleteUser = (userId) => {
    setConfirmationData({
      title: "Delete User",
      message: "Are you sure you want to delete this user?",
      onConfirm: async () => {
        try {
          const response = await fetchDeleteData(`lambdaAPI/User/delete/${userId}`);
          if (response.status === false) {
            setSnackbarMessage(response.message);
            setSnackbarOpen(true);
            return;
          }
          setSnackbarMessage("User deleted successfully");
          setSnackbarOpen(true);
          const updatedUsers = await fetchAllData(`lambdaAPI/User/GetUsersBySmartClinicId/${profile.SmartClinicId}`);
          setUsers(updatedUsers);
        } catch (error) {
          console.error("Error deleting user:", error);
          setSnackbarMessage("Failed to delete user. Please try again.");
          setSnackbarOpen(true);
        }
      }
    });
    setConfirmationOpen(true);
  };

  const handleEditUser = (userId) => {
    navigate(`/smart-clinics/${profile.SmartClinicId}/edit-user/${userId}`);
  };

  const handleViewUser = (userId) => {
    navigate(`/smart-clinics/${profile.SmartClinicId}/user/${userId}`);
  };

  const handleAssignHospitals = () => {
    setHospitalDialogOpen(true);
    fetchAllHospitals();
  };

  const handleAddUser = () => {
    navigate(`/smart-clinics/${profile.SmartClinicId}/add-user`);
  };

  const handleSubmitHospitalAssignment = async () => {
    if (selectedHospitals.length === 0) {
      setSnackbarMessage("Please select at least one hospital to assign.");
      setSnackbarOpen(true);
      return;
    }

    try {
      setLoading(true);
      const payload = {
        smartClinicId: profile.SmartClinicId,
        hospitalId: selectedHospitals
      };

      const response = await fetchData("lambdaAPI/SmartClinicHospitals/add", payload);

      if (response.status !== false) {
        setSnackbarMessage(`Successfully assigned ${selectedHospitals.length} hospital(s)`);
        setSnackbarOpen(true);
        setHospitalDialogOpen(false);
        setSelectedHospitals([]);
        fetchAssignedHospitals();
      } else {
        setSnackbarMessage(response.message || "Failed to assign hospitals");
        setSnackbarOpen(true);
      }
    } catch (error) {
      console.error("Error assigning hospitals:", error);
      setSnackbarMessage("Failed to assign hospitals. Please try again.");
      setSnackbarOpen(true);
    } finally {
      setLoading(false);
    }
  };

  const handleUpdateLocation = async () => {
    try {
      const response = await fetchData('Geocoding/forwardSmartClinicAddress', { smartClinicId: profile.SmartClinicId });
      window.location.reload();
    } catch (error) {
      console.error("Error fetching location data: ", error);
    }
  };

  const handleDelete = () => {
    setConfirmationData({
      title: "Delete Smart Clinic",
      message: "Are you sure you want to delete this Smart Clinic?",
      onConfirm: () => confirmhandleDelete(),
    });
    setConfirmationOpen(true);
  };

  const handleAssignedHospitalDelete = (SmartClinicHospitalsId) => {
    setConfirmationData({
      title: "Delete Assingned hospital",
      message: "Are you sure you want to delete this Assingned hospital?",
      onConfirm: () => confirmhandleHospitalDelete(SmartClinicHospitalsId),
    });
    setConfirmationOpen(true);
  }

  const confirmhandleHospitalDelete = async (SmartClinicHospitalsId) => {
    try {
      const response = await fetchDeleteData(`lambdaAPI/SmartClinicHospitals/delete/${SmartClinicHospitalsId}`);
      if (response.status === false) {
        setSnackbarMessage(response.message);
        setSnackbarOpen(true);
        return;
      }
      setSnackbarMessage(`Deleted Successfully`);
      setSnackbarOpen(false);
    } catch (error) {
      console.error("Error deleting event:", error);
      setSnackbarMessage("Failed to delete. Please try again.");
      setSnackbarOpen(true);
    } finally {
      setSnackbarOpen(false);
    }
  };

  const confirmhandleDelete = async () => {
    try {
      const response = await fetchDeleteData(`lambdaAPI/SmartClinics/delete/${Id}`);
      if (response.status === false) {
        setSnackbarMessage(response.message);
        setSnackbarOpen(true);
        return;
      }
      setSnackbarMessage(`Deleted Successfully`);
      setSnackbarOpen(true);

      setTimeout(() => {
        navigate("/SmartClinics/list");
      }, 2000);
    } catch (error) {
      console.error("Error deleting event:", error);
      setSnackbarMessage("Failed to delete. Please try again.");
      setSnackbarOpen(true);
    }
  };

  const requestActivation = (type, item) => {
    const message =
      type === "hospital"
        ? "Are you sure you want to activate this hospital in the community?"
        : "Are you sure you want to activate this group in the community?";

    setConfirm({
      message,
      action: async () => {
        try {
          const updatePayload =
            type === "hospital"
              ? [
                {
                  columnName: "IsActive",
                  columnValue: 1,
                  tableName: "SmartClinicHospitals",
                  tableId: item.SmartClinicHospitalsId,
                },
              ]
              : [
                {
                  columnName: "IsActive",
                  columnValue: 1,
                  tableName: "CommunityGroup",
                  tableId: item.CommunityGroupId,
                },
              ];

          await fetchUpdateData("lambdaAPI/Update/CommonUpdate", updatePayload);

          showToast(
            `${type === "hospital" ? "Hospital" : "Group"
            } activated successfully`
          );

          await fetchAssignedHospitals();
        } catch (err) {
          console.error("Activation failed", err);
          showToast("Activation failed", "danger");
        } finally {
          setConfirm(null);
        }
      },
    });
  };

  const filteredPatients = patients.filter(patient =>
    (patient.Name || '').toLowerCase().includes(patientSearch.toLowerCase()) ||
    (patient.MobileNumber || '').includes(patientSearch)
  );

  return (
    <div className="card shadow-sm border-0 rounded-4 mb-4">
      <div className="card-header bg-white border-0 p-4">
        <div className="d-flex flex-column flex-md-row align-items-start">
          <div className="mb-3 mb-md-0 me-md-4">
            {profile.SmartClinicImage ? (
              <img
                src={`${imageUrl}${profile.SmartClinicImage}`}
                alt=""
                className="rounded-3"
                style={{
                  height: "120px",
                  width: "140px",
                  objectFit: "cover"
                }}
              />
            ) : (
              <img
                src={`${process.env.PUBLIC_URL}/assets/clincdummyimage.jpg`}
                alt=""
                className="rounded-3"
                style={{
                  height: "120px",
                  width: "140px",
                  objectFit: "cover"
                }}
              />
            )}
          </div>

          <div className="flex-grow-1">
            <div className="d-flex flex-column flex-sm-row justify-content-between align-items-start mb-3">
              <h4 className="text-dark fw-bold mb-2 mb-sm-0">
                {profile.SmartClinicName}
              </h4>

              <div className="d-flex gap-2 flex-wrap">
                <button
                  className="btn btn-outline-primary btn-sm d-flex align-items-center"
                  onClick={handleAddUser}
                  title="Add User to Clinic"
                >
                  <i className="fas fa-user-plus me-1"></i>
                  Add User
                </button>
                <button
                  className="btn btn-outline-success btn-sm d-flex align-items-center"
                  onClick={handleAssignHospitals}
                  title="Assign Hospitals"
                >
                  <i className="fas fa-hospital me-1"></i>
                  Assign Hospitals
                </button>
                <button
                  className="btn btn-outline-danger btn-sm d-flex align-items-center"
                  onClick={handleDelete}
                  title="Delete Smart Clinic"
                >
                  <i className="fas fa-trash me-1"></i>
                  Delete
                </button>
              </div>
            </div>

            <div className="d-flex flex-wrap gap-3 mb-3">
              <div className="d-flex align-items-center">
                <strong className="me-2 text-dark">Status:</strong>
                <span className={`badge ${profile.IsActive ? 'bg-success' : 'bg-danger'}`}>
                  {profile.IsActive ? 'Active' : 'Inactive'}
                </span>
              </div>

              {profile.CreatedDate && (
                <div className="d-flex align-items-center">
                  <strong className="me-2 text-dark">Created:</strong>
                  <span className="text-muted">
                    {formatDate1(profile.CreatedDate)}
                  </span>
                </div>
              )}

              {profile.AddedBy && (
                <div className="d-flex align-items-center">
                  <strong className="me-2 text-dark">Added By:</strong>
                  <span className="text-muted">{profile.AddedBy}</span>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      {activeVideoCall && (
        <div className="alert alert-success border-0 m-3" role="alert">
          <div className="d-flex align-items-center justify-content-between">
            <div className="d-flex align-items-center">
              <div className="bg-success text-white rounded-circle me-3 d-flex align-items-center justify-content-center" style={{ width: '40px', height: '40px' }}>
                <i className="fas fa-video"></i>
              </div>
              <div>
                <h6 className="alert-heading mb-1">Active Video Call</h6>
                <p className="mb-0">
                  <strong>{activeVideoCall.doctorName}</strong> ↔ <strong>{activeVideoCall.patientName}</strong>
                  <br />
                  <small className="text-muted">Room: {activeVideoCall.roomName}</small>
                </p>
              </div>
            </div>
            <div className="d-flex gap-2">
              <button
                className="btn btn-success btn-sm"
                onClick={() => window.open(activeVideoCall.meetingUrl, '_blank')}
              >
                <i className="fas fa-external-link-alt me-1"></i>
                Join Meeting
              </button>
              <button
                className="btn btn-danger btn-sm"
                onClick={handleEndCall}
              >
                <i className="fas fa-phone-slash me-1"></i>
                End Call
              </button>
              <button
                className="btn btn-outline-secondary btn-sm"
                onClick={() => setActiveVideoCall(null)}
              >
                <i className="fas fa-times"></i>
              </button>
            </div>
          </div>
        </div>
      )}

      <div className="card-body p-4">
        <div className="row">
          <div className="col-12 col-lg-8 mb-4 mb-lg-0">
            <h5 className="text-success fw-semibold mb-3">
              <i className="fas fa-map-marker-alt me-2"></i>
              Location Information
            </h5>

            <div className="row g-3">
              {[
                { label: "City", value: profile.City, icon: "fa-solid fa-location-dot" },
                { label: "Pincode", value: profile.Pincode, icon: "fas fa-thumbtack" },
                { label: "Area", value: profile.Area, icon: "fas fa-map-marker-alt" },
                { label: "Mandal", value: profile.Mandal, icon: "fas fa-map" },
                { label: "Village", value: profile.Village, icon: "fas fa-tree" },
                { label: "Colony", value: profile.Colony, icon: "fas fa-building" },
                { label: "District", value: profile.DistrictName, icon: "fas fa-landmark" },
                { label: "State", value: profile.StateName, icon: "fas fa-flag" }
              ]
                .filter(item => item.value)
                .map((item, index) => (
                  <div key={index} className="col-md-6 col-lg-4">
                    <div className="d-flex align-items-center p-2 bg-light rounded-3">
                      <i className={`${item.icon} text-success me-2`}></i>
                      <div>
                        <div className="text-muted small">{item.label}</div>
                        <div className="fw-medium small">{item.value}</div>
                      </div>
                    </div>
                  </div>
                ))}
            </div>

            {profile.AddressLine1 && (
              <div className="mt-3">
                <h6 className="text-dark fw-semibold mb-2">Full Address</h6>
                <div className="p-3 bg-light rounded-3">
                  <i className="fas fa-home text-success me-2"></i>
                  {[
                    profile.AddressLine1,
                    profile.AddressLine2,
                    profile.Colony,
                    profile.Area,
                    profile.Village,
                    profile.Mandal,
                    profile.City,
                    profile.DistrictName,
                    profile.StateName,
                    profile.Pincode
                  ]
                    .filter(Boolean)
                    .join(', ')}
                </div>
              </div>
            )}
          </div>

          <div className="col-12 col-lg-4">
            <h5 className="text-success fw-semibold mb-3">
              <i className="fas fa-globe me-2"></i>
              Location Map
            </h5>

            <div className="border rounded-3 overflow-hidden" style={{ height: "300px" }}>
              {profile.Latitude && profile.Longitude ? (
                <MapBoxHospital hospitalsData={[profile]} />
              ) : (
                <div className="d-flex flex-column align-items-center justify-content-center h-100 bg-light">
                  <i className="fas fa-map-marker-alt text-muted mb-3" style={{ fontSize: "2rem" }}></i>
                  <span className="text-danger text-center mb-3">
                    Location coordinates not available
                  </span>
                  <button
                    className="btn btn-primary btn-sm"
                    onClick={handleUpdateLocation}
                  >
                    <i className="fas fa-sync-alt me-1"></i>
                    Update Location
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>

        <div className="card shadow-sm border-0 rounded-3">
          <div className="card-header bg-white border-0">
            <h5 className="text-primary fw-semibold mb-2 d-flex align-items-center">
              <i className="fas fa-hospital me-2"></i>
              Associated Hospitals ({assignedHospitals.length})
            </h5>

            <div className="d-flex gap-3 mt-4">
              <button
                type="button"
                className={`btn ${isActive ? "btn-success" : "btn-outline-success"} btn-md px-5`}
                onClick={() => setIsActive(true)}
              >
                Active
              </button>
              <button
                type="button"
                className={`btn ${!isActive ? "btn-danger" : "btn-outline-danger"} btn-md px-5`}
                onClick={() => setIsActive(false)}
              >
                Inactive
              </button>
            </div>
          </div>

          <div className="card-body">

            {assignedHospitals.length > 0 ? (
              <>



                <div className="row mt-4">
                  <div className="col-12">


                    {assignedHospitals.map((hospital, index) => {
                      const hospitalId = hospital.HospitalId || hospital.hospitalId;
                      const doctors = hospitalDoctors[hospitalId] || [];
                      const spocs = hospitalSpocs[hospitalId] || [];
                      const specializations = hospitalSpecializations[hospitalId] || [];
                      const isLoading = hospitalDetailsLoading[hospitalId];

                      return (
                        <div key={index} className="mb-4">
                          <Accordion
                            onChange={(event, expanded) => {
                              if (expanded && !doctors.length && !spocs.length && !specializations.length) {
                                fetchHospitalDetails(hospitalId);
                              }
                            }}
                          >
                            <AccordionSummary
                              expandIcon={<ExpandMore />}
                              aria-controls={`hospital-${index}-content`}
                              id={`hospital-${index}-header`}
                              className="bg-light"
                            >
                              <div className="d-flex align-items-center justify-content-between w-100 me-3">
                                <div className="d-flex align-items-center">
                                  <div className="bg-primary bg-opacity-10 rounded-circle p-2 me-3">
                                    <i className="bi bi-hospital text-white"></i>
                                  </div>
                                  <div>
                                    <Typography variant="h6" className="fw-bold">
                                      {hospital.HospitalName || hospital.hospitalName || 'Hospital Name'}
                                    </Typography>
                                    {(hospital.HospitalCode || hospital.hospitalCode) && (
                                      <Typography variant="body2" color="textSecondary">
                                        Code: {hospital.HospitalCode || hospital.hospitalCode}
                                      </Typography>
                                    )}
                                    <Typography variant="body2" className="mt-1">
                                      Smart clinic Hospital Status:{" "}
                                      {hospital.IsActive ? (
                                        <Chip label="Active" color="success" size="small" />
                                      ) : (
                                        <Chip label="Inactive" color="default" size="small" />
                                      )}
                                    </Typography>
                                    <Typography variant="body2" className="mt-1">
                                      Hospital Status:{" "}
                                      {hospital.IsHospitalActive ? (
                                        <Chip label="Active" color="success" size="small" />
                                      ) : (
                                        <Chip label="Inactive" color="default" size="small" />
                                      )}
                                    </Typography>
                                    {!hospital.IsHospitalActive && (
                                        <div className="alert alert-warning mt-2 mb-2">
                                          <i className="bi bi-exclamation-triangle me-2"></i>
                                          <small>
                                            Hospital is inactive. Please activate
                                            hospital in details page.
                                          </small>
                                        </div>
                                      )}
                                  </div>
                                </div>
                                <div className="d-flex gap-2 align-items-center mt-2">
                                  {/* Delete button - only if active */}
                                  {hospital.IsActive && (
                                    <button
                                      type="button"
                                      className="btn btn-sm btn-outline-danger"
                                      onClick={() => handleAssignedHospitalDelete(hospital.SmartClinicHospitalsId)}
                                    >
                                      <i className="bi bi-trash me-1"></i>
                                      Delete
                                    </button>
                                  )}

                                  {!hospital.IsActive && (
                                    <button
                                      className="btn btn-outline-success btn-sm"
                                      onClick={() =>
                                        requestActivation("hospital", hospital)
                                      }
                                      title="Activate Hospital in Community"
                                    >
                                      <i className="bi bi-check-circle me-1"></i>{" "}
                                      Activate
                                    </button>
                                  )}

                                  {/* Status Badge */}
                                  <span
                                    className={`badge ${hospital.IsActive ? "bg-success" : "bg-secondary"
                                      }`}
                                  >
                                    <i className="bi bi-check-circle me-1"></i>
                                    {hospital.IsActive ? "Associated" : "Inactive"}
                                  </span>

                                  {/* View Details button */}
                                  <button
                                    type="button"
                                    className="btn btn-sm btn-outline-primary"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      navigate(`/hospitals/details/${hospitalId}`);
                                    }}
                                  >
                                    <i className="bi bi-box-arrow-up-right me-1"></i>
                                    View Details
                                  </button>
                                </div>

                              </div>
                            </AccordionSummary>

                            <AccordionDetails>
                              {isLoading ? (
                                <div className="text-center py-4">
                                  <CircularProgress />
                                  <Typography className="mt-2" color="textSecondary">
                                    Loading hospital details...
                                  </Typography>
                                </div>
                              ) : (
                                <div className="row g-4">
                                  {specializations.length > 0 && (
                                    <div className="col-12">
                                      <h6 className="text-primary fw-semibold mb-3">
                                        <i className="fas fa-star-of-life me-2"></i>
                                        Hospital Specializations ({specializations.length})
                                      </h6>
                                      <div className="d-flex flex-wrap gap-2">
                                        {specializations.map((spec, idx) => (
                                          <span
                                            key={idx}
                                            className="badge bg-primary text-white px-3 py-2 rounded-pill"
                                          >
                                            <i className="fas fa-star-of-life me-1" style={{ fontSize: '10px' }}></i>
                                            {spec.ServiceName?.trim()}
                                          </span>
                                        ))}
                                      </div>
                                    </div>
                                  )}

                                  <div className="col-12">
                                    <h6 className="text-primary fw-semibold mb-3">
                                      <i className="fas fa-user-tie me-2"></i>
                                      SPOC Contacts ({spocs.length})
                                    </h6>

                                    {spocs.length > 0 ? (
                                      <div className="row g-3">
                                        {spocs.map((spoc) => {
                                          const badgeVariant = spoc.IsPrimary ? "primary" : spoc.IsSecondary ? "warning" : "secondary";
                                          return (
                                            <div key={spoc.HospitalContactId} className="col-12 col-md-6 col-lg-4">
                                              <div className="border rounded-3 p-3 bg-light h-100">
                                                <div className="d-flex align-items-start gap-3">
                                                  <div className="bg-primary text-white rounded-circle d-flex align-items-center justify-content-center" style={{ width: '40px', height: '40px' }}>
                                                    <i className="fas fa-user"></i>
                                                  </div>
                                                  <div className="flex-grow-1">
                                                    <div className="d-flex align-items-center gap-2 mb-2 flex-wrap">
                                                      <h6 className="mb-0 fw-bold small">{spoc.FullName}</h6>
                                                      <span className={`badge bg-${badgeVariant} text-white rounded-pill px-2 py-1`} style={{ fontSize: '10px' }}>
                                                        {spoc.IsPrimary ? "Primary" : "Secondary"}
                                                      </span>
                                                    </div>

                                                    <div className="mb-2">
                                                      <small className="text-muted d-flex align-items-center">
                                                        <i className="fas fa-phone text-primary me-2"></i>
                                                        <a href={`tel:${spoc.MobileNumber}`} className="text-decoration-none">
                                                          {spoc.MobileNumber || "N/A"}
                                                        </a>
                                                      </small>
                                                    </div>

                                                    {spoc.Email && (
                                                      <div className="mb-2">
                                                        <small className="text-muted d-flex align-items-center">
                                                          <i className="fas fa-envelope text-primary me-2"></i>
                                                          <a href={`mailto:${spoc.Email}`} className="text-decoration-none text-truncate">
                                                            {spoc.Email}
                                                          </a>
                                                        </small>
                                                      </div>
                                                    )}

                                                    {spoc.Qualification && (
                                                      <div className="mb-2">
                                                        <small className="text-muted">
                                                          <i className="fas fa-graduation-cap text-primary me-2"></i>
                                                          <span className="badge bg-info-subtle text-info rounded-pill">{spoc.Qualification}</span>
                                                        </small>
                                                      </div>
                                                    )}

                                                    {spoc.Address && (
                                                      <div>
                                                        <small className="text-muted d-flex">
                                                          <i className="fas fa-map-marker-alt text-primary me-2 mt-1" style={{ fontSize: '10px' }}></i>
                                                          <span className="text-truncate">{spoc.Address}</span>
                                                        </small>
                                                      </div>
                                                    )}
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          );
                                        })}
                                      </div>
                                    ) : (
                                      <div className="text-center py-3">
                                        <div className="bg-light rounded-circle mx-auto mb-2 d-flex align-items-center justify-content-center" style={{ width: '48px', height: '48px' }}>
                                          <i className="fas fa-user-tie text-muted"></i>
                                        </div>
                                        <small className="text-muted">No SPOC contacts found</small>
                                      </div>
                                    )}
                                  </div>

                                  <div className="col-12">
                                    <h6 className="text-success fw-semibold mb-3">
                                      <i className="fas fa-user-md me-2"></i>
                                      Medical Team ({doctors.length})
                                    </h6>

                                    {doctors.length > 0 ? (
                                      <div className="row g-4">
                                        {doctors.map((doctor, index) => {
                                          const todayTiming = getTodayTiming(doctor.DoctorId);
                                          const weekTimings = getWeekTimings(doctor.DoctorId);

                                          return (
                                            <div key={index} className="col-12">
                                              <div className="border rounded-3 p-4 bg-light">
                                                <div className="d-flex align-items-start mb-3">
                                                  <div className="bg-success text-white rounded-circle me-3 d-flex align-items-center justify-content-center" style={{ width: '48px', height: '48px' }}>
                                                    <i className="fas fa-user-md"></i>
                                                  </div>
                                                  <div className="flex-grow-1">
                                                    <div className="d-flex justify-content-between align-items-start">
                                                      <div>
                                                        <h6 className="mb-2 fw-bold">{doctor.FullName || "Unnamed Doctor"}</h6>
                                                        <span className="badge bg-secondary text-white rounded-pill px-3 py-1">
                                                          <i className="fas fa-graduation-cap me-1" style={{ fontSize: '10px' }}></i>
                                                          {doctor.Qualification || "Not specified"}
                                                        </span>
                                                      </div>
                                                      {/* <div className="d-flex gap-2">
                                                  <button
                                                    className="btn btn-success btn-sm d-flex align-items-center"
                                                    onClick={() => handleVideoCallDialog(doctor)}
                                                    title="Start Video Call with Patient"
                                                  >
                                                    <VideoCall fontSize="small" className="me-1" />
                                                    Video Call
                                                  </button>
                                                </div> */}
                                                    </div>
                                                  </div>
                                                </div>

                                                <div className="row g-2 mb-3">
                                                  <div className="col-md-6">
                                                    <div className="d-flex align-items-center p-2 border rounded-2 bg-white">
                                                      <i className="fas fa-phone text-primary me-2"></i>
                                                      <span className="text-truncate">{doctor.MobileNumber || "No phone"}</span>
                                                    </div>
                                                  </div>
                                                  <div className="col-md-6">
                                                    <div className="d-flex align-items-center p-2 border rounded-2 bg-white">
                                                      <i className="fas fa-envelope text-primary me-2"></i>
                                                      <span className="text-truncate">{doctor.Email || "No email"}</span>
                                                    </div>
                                                  </div>
                                                </div>

                                                {doctor.DoctorSpecialization?.length > 0 && (
                                                  <div className="mb-3">
                                                    <small className="fw-bold text-muted d-block mb-2">
                                                      <i className="fas fa-stethoscope me-1"></i> Medical Specializations
                                                    </small>
                                                    <div className="d-flex flex-wrap gap-2">
                                                      {doctor.DoctorSpecialization.map((spec, idx) => (
                                                        <span key={idx} className="badge bg-primary text-white rounded-pill px-3 py-2">
                                                          <i className="fas fa-medkit me-1" style={{ fontSize: '10px' }}></i>
                                                          {spec.ServiceName}
                                                        </span>
                                                      ))}
                                                    </div>
                                                  </div>
                                                )}

                                                <div className="border-top pt-3">
                                                  {todayTiming ? (
                                                    <div className="mt-3 p-3 bg-white border rounded-3 shadow-sm">
                                                      <div className="d-flex align-items-center justify-content-between flex-wrap gap-2">
                                                        <div className="d-flex align-items-center gap-3">
                                                          <div
                                                            className={`rounded-circle d-flex align-items-center justify-content-center ${todayTiming.isLeave ? 'bg-danger-subtle text-danger' :
                                                              todayTiming.isPartial ? 'bg-warning-subtle text-warning' :
                                                                todayTiming.isAvailable ? 'bg-success-subtle text-success' :
                                                                  'bg-secondary-subtle text-secondary'
                                                              }`}
                                                            style={{ width: '32px', height: '32px' }}
                                                          >
                                                            <i className={`fas ${todayTiming.isLeave ? 'fa-times' :
                                                              todayTiming.isPartial ? 'fa-clock' :
                                                                todayTiming.isAvailable ? 'fa-check' :
                                                                  'fa-minus'
                                                              }`} style={{ fontSize: '14px' }}></i>
                                                          </div>

                                                          <div>
                                                            <div className="d-flex align-items-center gap-2 mb-1">
                                                              <strong className="text-dark" style={{ fontSize: '14px' }}>Today:</strong>
                                                              <span className={`badge px-2 py-1 rounded-pill ${todayTiming.isLeave ? 'bg-danger text-white' :
                                                                todayTiming.isPartial ? 'bg-warning text-dark' :
                                                                  todayTiming.isAvailable ? 'bg-success text-white' :
                                                                    'bg-secondary text-white'
                                                                }`} style={{ fontSize: '11px' }}>
                                                                {todayTiming.isLeave ? 'ON LEAVE' :
                                                                  todayTiming.isPartial ? 'PARTIAL SCHEDULE' :
                                                                    todayTiming.isAvailable ? 'AVAILABLE' :
                                                                      'NO SCHEDULE'}
                                                              </span>
                                                            </div>

                                                            {todayTiming.isLeave ? (
                                                              <div>
                                                                <div className="text-danger fw-medium" style={{ fontSize: '13px' }}>
                                                                  Doctor is on leave today
                                                                </div>
                                                                {todayTiming.reason && (
                                                                  <div className="text-muted" style={{ fontSize: '11px' }}>
                                                                    Reason: {todayTiming.reason}
                                                                  </div>
                                                                )}
                                                              </div>
                                                            ) : todayTiming.isPartial ? (
                                                              <div>
                                                                <div className="text-success fw-medium mb-1" style={{ fontSize: '13px' }}>
                                                                  Available: {todayTiming.availableTime?.StartTime && todayTiming.availableTime?.EndTime
                                                                    ? `${formatTime(todayTiming.availableTime.StartTime)} - ${formatTime(todayTiming.availableTime.EndTime)}`
                                                                    : 'Time not specified'}
                                                                </div>
                                                                <div className="text-warning fw-medium" style={{ fontSize: '11px' }}>
                                                                  Break: {todayTiming.unavailableTime?.UnavailableStartTime && todayTiming.unavailableTime?.UnavailableEndTime
                                                                    ? `${formatTime(todayTiming.unavailableTime.UnavailableStartTime)} - ${formatTime(todayTiming.unavailableTime.UnavailableEndTime)}`
                                                                    : 'Break time not specified'}
                                                                </div>
                                                                {todayTiming.reason && (
                                                                  <div className="text-muted" style={{ fontSize: '11px' }}>
                                                                    Note: {todayTiming.reason}
                                                                  </div>
                                                                )}
                                                              </div>
                                                            ) : todayTiming.isAvailable ? (
                                                              <div>
                                                                <div className="text-success fw-medium" style={{ fontSize: '13px' }}>
                                                                  {todayTiming.availableTime?.StartTime && todayTiming.availableTime?.EndTime
                                                                    ? `${formatTime(todayTiming.availableTime.StartTime)} - ${formatTime(todayTiming.availableTime.EndTime)}`
                                                                    : 'Available (Time not specified)'}
                                                                </div>
                                                                <div className="text-muted" style={{ fontSize: '11px' }}>
                                                                  Full day availability
                                                                </div>
                                                              </div>
                                                            ) : (
                                                              <div>
                                                                <div className="text-muted fw-medium" style={{ fontSize: '13px' }}>
                                                                  No schedule set for today
                                                                </div>
                                                                <div className="text-muted" style={{ fontSize: '11px' }}>
                                                                  Please check weekly schedule or contact directly
                                                                </div>
                                                              </div>
                                                            )}
                                                          </div>
                                                        </div>

                                                        <div className="badge bg-primary text-white px-3 py-2 rounded-pill" style={{ fontSize: '10px' }}>
                                                          <i className="fas fa-calendar-day me-1"></i>
                                                          TODAY
                                                        </div>
                                                      </div>
                                                    </div>
                                                  ) : (
                                                    <div className="mt-3 p-3 bg-light border rounded-3 text-center">
                                                      <div className="text-muted mb-2">
                                                        <i className="fas fa-calendar-times" style={{ fontSize: '24px' }}></i>
                                                      </div>
                                                      <div className="text-muted fw-medium" style={{ fontSize: '13px' }}>
                                                        No timing data available for today
                                                      </div>
                                                      <div className="text-muted" style={{ fontSize: '11px' }}>
                                                        Please check the weekly schedule below
                                                      </div>
                                                    </div>
                                                  )}

                                                  <h6 className="fw-bold mb-3 text-dark mt-2">
                                                    <i className="fas fa-calendar-week me-2 text-primary"></i>Weekly Schedule
                                                  </h6>

                                                  <div className="table-responsive">
                                                    <table className="table table-sm table-bordered mb-0">
                                                      <thead className="table-light">
                                                        <tr>
                                                          {weekTimings.map((day, dayIndex) => (
                                                            <th key={dayIndex} className={`text-center ${day.isToday ? 'bg-primary-subtle' : ''}`} style={{ fontSize: '11px' }}>
                                                              {day.dayOfWeek}
                                                            </th>
                                                          ))}
                                                        </tr>
                                                      </thead>
                                                      <tbody>
                                                        <tr>
                                                          {weekTimings.map((day, dayIndex) => (
                                                            <td key={dayIndex} className={`text-center p-2 ${day.isToday ? 'bg-primary-subtle' : ''}`} style={{ fontSize: '10px', minWidth: '80px' }}>
                                                              {day.isLeave ? (
                                                                <div className="text-danger">
                                                                  <i className="fas fa-times d-block mb-1"></i>
                                                                  <span className="fw-medium">Leave</span>
                                                                  {day.reason && (
                                                                    <div className="text-muted" style={{ fontSize: '8px' }}>{day.reason}</div>
                                                                  )}
                                                                </div>
                                                              ) : day.isPartial ? (
                                                                <div className="text-warning">
                                                                  <i className="fas fa-clock d-block mb-1"></i>
                                                                  <div className="text-success fw-medium mb-1">
                                                                    {formatTime(day.availableTime?.StartTime)}-{formatTime(day.availableTime?.EndTime)}
                                                                  </div>
                                                                  <div className="text-warning" style={{ fontSize: '8px' }}>
                                                                    Break: {formatTime(day.unavailableTime?.UnavailableStartTime)}-{formatTime(day.unavailableTime?.UnavailableEndTime)}
                                                                  </div>
                                                                </div>
                                                              ) : day.isAvailable ? (
                                                                <div className="text-success">
                                                                  <i className="fas fa-check d-block mb-1"></i>
                                                                  <div className="fw-medium">
                                                                    {formatTime(day.availableTime?.StartTime)}-{formatTime(day.availableTime?.EndTime)}
                                                                  </div>
                                                                </div>
                                                              ) : (
                                                                <div className="text-muted">
                                                                  <i className="fas fa-minus d-block mb-1"></i>
                                                                  <span>No Schedule</span>
                                                                </div>
                                                              )}
                                                            </td>
                                                          ))}
                                                        </tr>
                                                      </tbody>
                                                    </table>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          );
                                        })}
                                      </div>
                                    ) : (
                                      <div className="text-center py-4">
                                        <div className="bg-light rounded-circle mx-auto mb-3 d-flex align-items-center justify-content-center" style={{ width: '64px', height: '64px' }}>
                                          <i className="fas fa-user-md text-muted fs-3"></i>
                                        </div>
                                        <h6 className="text-muted">No Doctors Found</h6>
                                      </div>
                                    )}
                                  </div>
                                </div>
                              )}
                            </AccordionDetails>
                          </Accordion>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </>
            ) : (
              <div className="text-center py-5">
                <div
                  className="bg-light rounded-circle mx-auto mb-3 d-flex align-items-center justify-content-center"
                  style={{ width: "64px", height: "64px" }}
                >
                  <i className="bi bi-hospital text-muted fs-3"></i>
                </div>
                <h6 className="text-muted">No Associated Hospitals Found</h6>
                <p className="text-secondary small mb-3">
                  Please assign hospitals to see them here.
                </p>

                <button
                  type="button"
                  className="btn btn-sm btn-outline-success d-flex align-items-center mx-auto"
                  onClick={handleAssignHospitals}
                  title="Assign Hospitals"
                >
                  <i className="bi bi-hospital me-1"></i>
                  Assign Hospitals
                </button>
              </div>
            )}
          </div>
        </div>

        {users.length > 0 && (
          <div className="row mt-4">
            <div className="col-12">
              <h5 className="text-primary fw-semibold mb-3">
                <i className="fas fa-users me-2"></i>
                Users ({users.length})
              </h5>

              <div className="card shadow-sm border-0 rounded-4">
                <div className="card-body p-0">
                  <TableContainer component={Paper}>
                    <Table>
                      <TableHead>
                        <TableRow>
                          <TableCell>Profile</TableCell>
                          <TableCell>Name</TableCell>
                          <TableCell>Mobile</TableCell>
                          <TableCell>Gender</TableCell>
                          <TableCell>Age</TableCell>
                          <TableCell>Qualification</TableCell>
                          <TableCell>Actions</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {users.map((user) => (
                          <TableRow key={user.UserId} hover>
                            <TableCell>
                              <Avatar
                                src={user.UserImage ? `${imageUrl}${user.UserImage}` : `${process.env.PUBLIC_URL}/assets/user-default.png`}
                                alt={user.FullName}
                              />
                            </TableCell>
                            <TableCell>{user.FullName}</TableCell>
                            <TableCell>{user.MobileNumber}</TableCell>
                            <TableCell>{user.Gender}</TableCell>
                            <TableCell>{user.Age}</TableCell>
                            <TableCell>{user.Qualification}</TableCell>
                            <TableCell>
                              <IconButton onClick={() => handleViewUser(user.UserId)} color="primary">
                                <Tooltip title="View">
                                  <Visibility fontSize="small" />
                                </Tooltip>
                              </IconButton>
                              <IconButton onClick={() => handleEditUser(user.UserId)} color="secondary">
                                <Tooltip title="Edit">
                                  <Edit fontSize="small" />
                                </Tooltip>
                              </IconButton>
                              <IconButton onClick={() => handleDeleteUser(user.UserId)} color="error">
                                <Tooltip title="Delete">
                                  <Delete fontSize="small" />
                                </Tooltip>
                              </IconButton>
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </div>
              </div>
            </div>
          </div>
        )}

        {usersLoading && (
          <div className="text-center py-4">
            <CircularProgress />
            <p className="text-muted mt-2">Loading users...</p>
          </div>
        )}

        {!usersLoading && users.length === 0 && (
          <div className="text-center py-4">
            <i className="fas fa-users text-muted" style={{ fontSize: "3rem" }}></i>
            <p className="text-muted mt-2">No users found for this clinic</p>
            <button
              className="btn btn-primary mt-2"
              onClick={handleAddUser}
            >
              <i className="fas fa-user-plus me-2"></i>
              Add New User
            </button>
          </div>
        )}
      </div>

      <Dialog
        open={hospitalDialogOpen}
        onClose={() => setHospitalDialogOpen(false)}
        maxWidth="md"
        fullWidth
        PaperProps={{
          style: {
            borderRadius: '16px',
            maxHeight: '80vh'
          }
        }}
      >
        <DialogTitle className="bg-light">
          <div className="d-flex align-items-center">
            <i className="fas fa-hospital text-primary me-2"></i>
            <span className="fw-bold">Assign Hospitals to {profile.SmartClinicName}</span>
          </div>
        </DialogTitle>

        <DialogContent className="p-4">
          {hospitalLoading ? (
            <div className="text-center py-5">
              <CircularProgress />
              <p className="text-muted mt-3">Loading hospitals...</p>
            </div>
          ) : (
            <div>
              <div className="mb-4">
                <label className="form-label fw-semibold mb-2" style={{ color: '#374151' }}>
                  <i className="fas fa-hospital me-2 text-primary"></i>
                  Select Hospitals to Assign
                </label>
                <Select
                  options={hospitalOptions}
                  isMulti
                  placeholder="Search and select hospitals..."
                  closeMenuOnSelect={false}
                  value={hospitalOptions.filter((o) => selectedHospitals.includes(o.value))}
                  onChange={(opts) => setSelectedHospitals(opts ? opts.map((o) => o.value) : [])}
                  styles={{
                    ...selectStyles,
                    menuPortal: (base) => ({ ...base, zIndex: 9999 }), // ensures it's always on top
                  }}
                  classNamePrefix="react-select"
                  isSearchable
                  noOptionsMessage={() => "No hospitals available for assignment"}
                  menuPortalTarget={document.body} // render menu at the root body
                />

                <small className="text-secondary mt-2 d-block">
                  <i className="fas fa-info-circle me-1"></i>
                  {hospitalOptions.length} hospitals available for assignment
                </small>
              </div>

              {selectedHospitals.length > 0 && (
                <div className="mt-3">
                  <h6 className="fw-semibold text-dark mb-2">Selected Hospitals:</h6>
                  <div className="d-flex flex-wrap gap-2">
                    {hospitalOptions
                      .filter(option => selectedHospitals.includes(option.value))
                      .map(option => (
                        <Chip
                          key={option.value}
                          label={option.label}
                          variant="outlined"
                          color="primary"
                          size="small"
                        />
                      ))}
                  </div>
                </div>
              )}

              {assignedHospitals.length > 0 && (
                <div className="mt-4 p-3 bg-light rounded-3">
                  <h6 className="fw-semibold text-success mb-2">
                    <i className="fas fa-check-circle me-1"></i>
                    Already Assigned ({assignedHospitals.length})
                  </h6>
                  <div className="d-flex flex-wrap gap-1">
                    {assignedHospitals.map((hospital, index) => (
                      <Chip
                        key={index}
                        label={hospital.HospitalName || hospital.hospitalName}
                        size="small"
                        color="success"
                        variant="filled"
                      />
                    ))}
                  </div>
                </div>
              )}
            </div>
          )}
        </DialogContent>

        <DialogActions className="p-3 bg-light">
          <Button
            onClick={() => setHospitalDialogOpen(false)}
            color="inherit"
            variant="outlined"
          >
            Cancel
          </Button>
          <Button
            onClick={handleSubmitHospitalAssignment}
            color="primary"
            variant="contained"
            disabled={loading || selectedHospitals.length === 0}
            startIcon={loading && <CircularProgress size={16} />}
          >
            {loading ? 'Assigning...' : `Assign ${selectedHospitals.length} Hospital${selectedHospitals.length !== 1 ? 's' : ''}`}
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={videoCallDialogOpen}
        onClose={() => setVideoCallDialogOpen(false)}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          style: {
            borderRadius: '16px'
          }
        }}
      >
        <DialogTitle className="bg-light">
          <div className="d-flex align-items-center">
            <div className="bg-success text-white rounded-circle me-3 d-flex align-items-center justify-content-center" style={{ width: '40px', height: '40px' }}>
              <VideoCall />
            </div>
            <div>
              <span className="fw-bold">Initiate Video Call</span>
              {selectedDoctor && (
                <div className="small text-muted">
                  Dr. {selectedDoctor.FullName}
                </div>
              )}
            </div>
          </div>
        </DialogTitle>

        <DialogContent className="p-4">
          {patientsLoading ? (
            <div className="text-center py-4">
              <CircularProgress />
              <p className="text-muted mt-3">Loading patients...</p>
            </div>
          ) : (
            <div>
              <div className="mb-4">
                <label className="form-label fw-semibold mb-2" style={{ color: '#374151' }}>
                  <i className="fas fa-user-injured me-2 text-success"></i>
                  Select Patient for Video Call
                </label>
                <TextField
                  fullWidth
                  variant="outlined"
                  placeholder="Search patients by name or mobile..."
                  value={patientSearch}
                  onChange={(e) => setPatientSearch(e.target.value)}
                  className="mb-3"
                  InputProps={{
                    startAdornment: <i className="fas fa-search text-muted me-2"></i>,
                  }}
                />

                {filteredPatients.length > 0 ? (
                  <div className="row g-3" style={{ maxHeight: '300px', overflowY: 'auto' }}>
                    {filteredPatients.map((patient) => (
                      <div key={patient.CustomerId} className="col-12">
                        <div
                          className={`border rounded-3 p-3 cursor-pointer transition-all ${selectedPatient?.CustomerId === patient.CustomerId
                            ? 'border-success bg-success-subtle shadow-sm'
                            : 'bg-light hover:bg-gray-50'
                            }`}
                          onClick={() => setSelectedPatient(patient)}
                          style={{ cursor: 'pointer' }}
                        >
                          <div className="d-flex align-items-center">
                            <div className="bg-primary text-white rounded-circle me-3 d-flex align-items-center justify-content-center" style={{ width: '40px', height: '40px' }}>
                              <i className="fas fa-user"></i>
                            </div>
                            <div className="flex-grow-1">
                              <div className="fw-medium">{patient.Name || 'Patient'}</div>
                              <div className="small text-muted">
                                <i className="fas fa-phone me-1"></i>
                                {patient.MobileNumber || 'No phone'}
                                {patient.Age && (
                                  <>
                                    <span className="mx-2">•</span>
                                    <i className="fas fa-birthday-cake me-1"></i>
                                    Age: {patient.Age}
                                  </>
                                )}
                              </div>
                              {patient.Email && (
                                <div className="small text-muted">
                                  <i className="fas fa-envelope me-1"></i>
                                  {patient.Email}
                                </div>
                              )}
                            </div>
                            {(selectedPatient?.CustomerId === patient.CustomerId) && (
                              <div className="text-success">
                                <i className="fas fa-check-circle fs-4"></i>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                ) : (
                  <div className="text-center py-4">
                    <div className="bg-light rounded-circle mx-auto mb-3 d-flex align-items-center justify-content-center" style={{ width: '64px', height: '64px' }}>
                      <i className="fas fa-user-injured text-muted fs-3"></i>
                    </div>
                    <h6 className="text-muted mb-2">No Patients Found</h6>
                    <p className="text-muted small">No patients are associated with this smart clinic.</p>
                  </div>
                )}
              </div>

              {selectedDoctor && selectedPatient && (
                <div className="mt-4 p-3 bg-light rounded-3">
                  <h6 className="fw-semibold text-dark mb-2">
                    <i className="fas fa-video me-1 text-success"></i>
                    Call Details
                  </h6>
                  <div className="row g-2">
                    <div className="col-6">
                      <div className="small text-muted">Doctor</div>
                      <div className="fw-medium">Dr. {selectedDoctor.FullName}</div>
                    </div>
                    <div className="col-6">
                      <div className="small text-muted">Patient</div>
                      <div className="fw-medium">{selectedPatient.Name}</div>
                    </div>
                  </div>
                  <div className="mt-2">
                    <div className="small text-success">
                      <i className="fas fa-info-circle me-1"></i>
                      A video call room will be created and both participants will be notified.
                    </div>
                  </div>
                </div>
              )}
            </div>
          )}
        </DialogContent>

        <DialogActions className="p-3 bg-light">
          <Button
            onClick={() => {
              setVideoCallDialogOpen(false);
              setSelectedDoctor(null);
              setSelectedPatient(null);
              setPatientSearch('');
            }}
            color="inherit"
            variant="outlined"
          >
            Cancel
          </Button>
          <Button
            onClick={() => initiateVideoCall(
              selectedDoctor?.DoctorId || selectedDoctor?.id,
              selectedPatient?.CustomerId || selectedPatient?.id
            )}
            color="success"
            variant="contained"
            disabled={videoCallLoading || !selectedDoctor || !selectedPatient}
            startIcon={videoCallLoading ? <CircularProgress size={16} /> : <VideoCall />}
          >
            {videoCallLoading ? 'Starting Call...' : 'Start Video Call'}
          </Button>
        </DialogActions>
      </Dialog>

      <TableContainer component={Paper}>
        <ConfirmationDialogDelete
          open={confirmationOpen}
          title={confirmationData.title}
          message={confirmationData.message}
          onConfirm={confirmationData.onConfirm}
          onCancel={() => setConfirmationOpen(false)}
        />
        <Snackbar
          open={snackbarOpen}
          autoHideDuration={6000}
          onClose={handleSnackbarClose}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
        >
          <Alert onClose={handleSnackbarClose} severity="success">
            {snackbarMessage}
          </Alert>
        </Snackbar>
      </TableContainer>


      {confirm && (
        <div
          className="position-fixed top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center"
          style={{ backgroundColor: "rgba(0,0,0,0.5)", zIndex: 1080 }}
        >
          <div
            className="card shadow"
            style={{ maxWidth: "420px", borderRadius: "6px" }}
          >
            <div className="card-body p-4">
              <h5 className="card-title">Confirm</h5>
              <p className="mb-4">{confirm.message}</p>
              <div className="d-flex justify-content-end gap-2">
                <button
                  className="btn btn-outline-secondary"
                  onClick={() => setConfirm(null)}
                >
                  Cancel
                </button>
                <button className="btn btn-success" onClick={confirm.action}>
                  Confirm
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Toast */}
      {toast.show && (
        <div
          className={`toast align-items-center text-white bg-${toast.variant} border-0 position-fixed top-0 end-0 m-3 show`}
          style={{ zIndex: 1090 }}
          role="alert"
        >
          <div className="d-flex">
            <div className="toast-body">{toast.message}</div>
            <button
              type="button"
              className="btn-close btn-close-white me-2 m-auto"
              aria-label="Close"
              onClick={() => setToast({ ...toast, show: false })}
            ></button>
          </div>
        </div>
      )}
    </div>
  );
}